module.exports = __webpack_public_path__ + "img/600.c094edc7.jpg";